import { useMutation } from '@apollo/client/react';

import {
  GetCheckinSettingDocument,
  UpdateCheckinSettingDocument,
} from '~/graphql/generated/graphql';
import { useCheckinSetting } from '~/hooks/use-checkin-setting';

export const useCheckin = () => {
  const { loading, isActive, checkinOrganizationId, refetchCheckinSetting } = useCheckinSetting();
  const [updateCheckinSetting, { loading: updating }] = useMutation(UpdateCheckinSettingDocument, {
    refetchQueries: [{ query: GetCheckinSettingDocument }],
  });

  return {
    loading,
    updating,
    isActive,
    checkinOrganizationId,
    refetchCheckinSetting,
    updateCheckinSetting,
  };
};
